// extracted by mini-css-extract-plugin
export default {"wrapper":"Checkbox_wrapper__0rI-+","input":"Checkbox_input__eVCgi","label":"Checkbox_label__p6SNH"};